import { cn } from "@/lib/utils";

type PGFlowStatusBadgeProps = {
	status?: string | null;
	remainingSteps?: number | null;
	className?: string;
	testId?: string;
};

const STATUS_COLORS: Record<string, string> = {
	queued: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
	running:
		"bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
	evaluating:
		"bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
	completed:
		"bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
	failed: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};

export const PGFlowStatusBadge = ({
	status,
	className,
	testId = "pgflow-status-badge",
}: PGFlowStatusBadgeProps) => {
	if (!status) {
		return (
			<span
				data-testid={testId}
				className={cn("text-xs text-muted-foreground", className)}
				data-status="unknown"
			>
				—
			</span>
		);
	}

	const normalized = status.toLowerCase();
	const label = status.charAt(0).toUpperCase() + status.slice(1);
	const colorClasses = STATUS_COLORS[normalized] ?? STATUS_COLORS["queued"];

	return (
		<span
			data-testid={testId}
			data-status={normalized}
			className={cn(
				"inline-flex items-center px-2 py-1 rounded-full text-xs font-medium",
				colorClasses,
				className,
			)}
		>
			{label}
		</span>
	);
};
